export function formatData(val) {
  if (!val) return "-";
  
  if (val?.toDate) {
    const d = val.toDate();
    return d.toLocaleDateString("pt-BR");
  }
  
  if (val instanceof Date) {
    return val.toLocaleDateString("pt-BR");
  }
  
  if (typeof val === "string") {
    if (val.includes("/")) return val.split(" ")[0];
    const d = new Date(val);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString("pt-BR");
    }
  }
  
  return "-";
}

export function formatHora(val) {
  if (!val) return "-";
  
  if (val?.toDate) {
    const d = val.toDate();
    return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  }
  
  if (val instanceof Date) {
    return val.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  }
  
  if (typeof val === "string") {
    if (val.includes(":") && val.length <= 5) return val;
    const d = new Date(val);
    if (!isNaN(d.getTime())) {
      return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    }
  }
  
  return "-";
}

export function formatDataHora(val) {
  if (!val) return "-";
  return `${formatData(val)} ${formatHora(val)}`;
}

export function timestampToDate(ts) {
  if (!ts) return null;
  if (ts?.toDate) return ts.toDate();
  if (ts instanceof Date) return ts;
  if (typeof ts === "string") {
    const d = new Date(ts);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}
